import React from "react";
import { OverviewContainer, SkuContainer } from "../../MoneyReceiptView";
import { arrayMap } from "../../../utils/array.utils";
import StockListLocation from "../../StockList/StockListLocation";
import StockListForward from "../../StockList/StockListForward";
import StockListPrice from "../../StockList/StockListPrice";
import { OverviewItem, OverviewItemSkeleton } from "..";
import CardLayout from "../../../layouts/CardLayout";
import Skeleton from "react-loading-skeleton";

export default function VehicleOverview({ data }) {
  const { carInfos, mileage, eta_date, location, forward_price, company, features } = data;
  return (
    <CardLayout>
      <SkuContainer>Overview</SkuContainer>
      <OverviewContainer className="list-unstyled">
        {arrayMap(
          [...carInfos]?.filter(
            (carInfo) =>
              !["features", "company", "car-location"].includes(carInfo?.car_info_type?.slug)
          ),
          (carInfo) => (
            <OverviewItem
              key={carInfo?.car_info_type_id}
              label={carInfo?.car_info_type?.name ?? ""}
              value={carInfo?.name ?? ""}
            />
          )
        )}

        <OverviewItem label={"Mileage"} value={mileage} />
        <OverviewItem
          label={"Location"}
          value={<StockListLocation date={eta_date} location={location} />}
        />
        <OverviewItem
          label={"Forward"}
          value={<StockListForward price={forward_price} company={company} />}
        />
        <OverviewItem
          label={"Price"}
          value={<StockListPrice asking={data?.asking_price} sale={data?.discount_price} />}
        />
      </OverviewContainer>

      <div>
        <SkuContainer>Features</SkuContainer>
        <p>{features?.length ? features?.join(", ") : "-"}</p>
      </div>
    </CardLayout>
  );
}

// VehicleOverview skeleton
export function VehicleOverviewSkeleton() {
  return (
    <CardLayout>
      <SkuContainer>
        <Skeleton width={`30%`} />
      </SkuContainer>
      <OverviewContainer className="list-unstyled">
        {arrayMap(Array(13).fill(0), (_, i) => (
          <OverviewItemSkeleton key={i} />
        ))}
      </OverviewContainer>

      <div>
        <SkuContainer>
          <Skeleton width={`30%`} />
        </SkuContainer>
        <p>
          <Skeleton />
        </p>
      </div>
    </CardLayout>
  );
}
